/**
 * Last-played storage — a resilient backup of each track's last play time,
 * keyed by stable identifiers so data survives filename/id changes.
 */
import { z } from "zod";
/**
 * Maps of keys to unix-second timestamps. Two key schemes are used:
 *   - `owner:filename` (original name) — stable across library rebuilds
 *   - `metadata:artist|title` — survives filename corruption/renames
 */
export const LastPlayedFileSchema = z.record(z.string(), z.number().int());
//# sourceMappingURL=lastPlayed.js.map